export {};
//# sourceMappingURL=glTFLoaderExtension.js.map